<template>
  <div class="404">
    <v-sheet>
      <v-img class="mt-10" src="@/assets/image404.png" alt="404 error"></v-img>
    </v-sheet>
    <v-container>
      <v-row>
        <v-col cols="12" align="center">
          <h1 class="primary--text">404</h1>
          <h2>Page not found</h2>
          <v-btn class="mt-3" to="/" color="primary">Go back</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Page404',
  components: {},
  data: () => ({}),
}
</script>
